import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';

const CustomSelectField = ({id, label, disabled, options, value, onChange, error, helperText}) => {
  const handleChange = (e) => {
    e.target.id = id;
    onChange(e);
  };
  return (
    <>
      <FormControl size="small" sx={{m: 1, minWidth: 215}} disabled={disabled} error={error}>
        <InputLabel>{label}</InputLabel>
        <Select id={id} label={label} value={value} onChange={handleChange}>
          {Array.isArray(options) &&
            options.map((option, index) => (
              <MenuItem key={index} value={option?.code}>
                {option?.label}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

export default CustomSelectField;
